module.exports = __webpack_public_path__ + "static/henho3-1118cd33855911bb03581985d42bf6f5.jpg";